import { 
  createTableActionItem, 
  createTableColumn, 
  createTableColumnSlot, 
  createTableHeaderButton 
} from "@/component-create/utils/create-table-column"
import { Table } from "@/component-create/Table"
import { MAIL_TYPE } from "@/constant/system/code"
import { formatter } from "@/utils/common"
import { MAIL_PAGE_URL } from "@/api/system/mail"
import { ElLink, ElForm, ElFormItem, ElPopover } from "element-plus"
import { View } from '@element-plus/icons-vue'

import MailCssModule from './mail.module.scss'

type MailRow = TColumnControls<'rowDelete' | 'rowEdit' | 'rowSend' | 'rowShow'>
type MailHeader = THeaderControls<'addFn' | 'deleteFn' | 'editFn' | 'contactsFn'>

export const createTable = (
  el: Element,
  row: MailRow,
  header: MailHeader
) => {
  const _table = new Table(
    el, 
    column(row), 
    headerButtons(header), 
    { border: true }, 
    MAIL_PAGE_URL
  )

  return _table
}

export const column = (rowFn: MailRow) => {
  const col: TableColumnProp[] = [
    { type: 'selection' },
    { label: '序号', type: 'index', width: '60' },
    createTableColumn('名称', 'mailName'),
    createTableColumn('代码', 'mailCode'),
    createTableColumn('主题', 'mailSubject', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumnSlot('内容', (row) => {
      return (
        <ElLink  
          onClick={() => { rowFn.rowShow(row, []) }} 
          type="primary" 
          underline={false} 
          icon={View}>
            <span style={{ paddingLeft: '8px' }}>查看内容</span>
        </ElLink>
      )
    }, { width: '120' }),
    
    createTableColumnSlot('收件人', (row) => {
      return (
        <ElPopover 
          width={270}
          placement="right"
          title="收件人信息"
          trigger="hover"
          v-slots={{
            reference: () => (
              <ElLink type="primary" underline={false} icon={View}><span style={{ paddingLeft: '8px' }}>查看收件人</span></ElLink>
            )
          }}
        >
          <ElForm label-width="40px" size="small" class={ MailCssModule.showReceiverNameLabel }>
            {
              row.to ? 
              <ElFormItem style={{ marginBottom: 0 }} label="收件">{ renderReceiverName(row.to) }</ElFormItem>
              : ''
            }
            {
              row.cc ? 
              <ElFormItem style={{ marginBottom: 0 }} label="抄送">{ renderReceiverName(row.cc) }</ElFormItem>
              : '2'
            }
            {
              row.to ? 
              <ElFormItem style={{ marginBottom: 0 }} label="密送">{ renderReceiverName(row.cc) }</ElFormItem>
              : '2'
            }
          </ElForm>
        </ElPopover>
      )
    }, { width: '120' }),
    createTableColumn('类型', 'mailType', '100', 'center', { formatter: row => formatter(MAIL_TYPE, row.mailType) }),
    createTableColumn('备注', 'remark', undefined, undefined, { showOverflowTooltip: true }),
    createTableColumn('创建时间', 'createdAt', '150', 'center'),
    createTableColumn('操作', undefined, '200', 'center', {
      controller: [
        createTableActionItem('编辑', 'Edit', rowFn.rowEdit),
        createTableActionItem('删除', 'Delete', rowFn.rowDelete),
        createTableActionItem('发送', 'Position', rowFn.rowSend),
      ]
    }),
  ]
  return col
}


/**
 * 表格头部按钮
 */
function headerButtons(table: MailHeader) {
  return [
    createTableHeaderButton('新增', 'primary', 'Plus', table.addFn),
    createTableHeaderButton('编辑', 'primary', 'Edit', table.editFn),
    createTableHeaderButton('删除', 'primary', 'Delete', table.deleteFn),
    createTableHeaderButton('联系人维护', 'primary', 'User', table.contactsFn),
  ]
} 

function renderReceiverName(arr: { recipientName: string; mailAddress: string }[]) {
  return (<div>
    {
      arr.map(i => {
        return (
          <span style={{ display: 'block' }}>
            { i.recipientName } - { i.mailAddress }
          </span>
        )
      })
    }
  </div>)
}